import { render, staticRenderFns } from "./YearBadge.vue?vue&type=template&id=206d7e3e&scoped=true"
import script from "./YearBadge.vue?vue&type=script&lang=js"
export * from "./YearBadge.vue?vue&type=script&lang=js"
import style0 from "./YearBadge.vue?vue&type=style&index=0&id=206d7e3e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d7e3e",
  null
  
)

export default component.exports